import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback, Fragment } from 'react';
import { Action } from '@hh.ru/magritte-ui-action';
import { EllipsisHorizontalOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { N as NavigationBarItem } from './NavigationBarItem-BQ6pdgfa.js';
import { MAX_ICONS } from './types.js';
import 'classnames';
import '@hh.ru/magritte-ui-link';

const defaultRenderFunc = () => null;
const NavigationBarItems = ({ items, size, renderFunc = defaultRenderFunc }) => {
    const [ellipsis, setEllipsis] = useState(false);
    const toggleEllipsis = useCallback(() => setEllipsis(!ellipsis), [ellipsis, setEllipsis]);
    if (!items) {
        return null;
    }
    if (items && 'length' in items) {
        if (size === 'standard' && items.length > 2) {
            return (jsxs(Fragment, { children: [ellipsis && renderFunc(items.slice(-MAX_ICONS, -1)), jsx(NavigationBarItem, { "data-qa": "navigation-bar-ellipsis", item: jsx(Action, { icon: EllipsisHorizontalOutlinedSize24, onClick: toggleEllipsis }), transitionWithOpacity: true }), jsx(NavigationBarItem, { role: "menuitem", item: items[items.length - 1] })] }));
        }
        return (jsx(Fragment, { children: items.slice(-MAX_ICONS).map((item, index) => (jsx(NavigationBarItem, { role: "menuitem", item: item, transitionWithOpacity: index !== items.length - 1 && (index !== items.length - 2 || items.length !== 2) }, item.key || index))) }));
    }
    return jsx(NavigationBarItem, { role: "menuitem", item: items });
};

export { NavigationBarItems };
//# sourceMappingURL=NavigationBarItems.js.map
